export default __webpack_public_path__ + "static/media/Moellers Group.f97fb9b0.png";